import { render, staticRenderFns } from "./DashboardList.vue?vue&type=template&id=020a85ef&scoped=true&"
import script from "./DashboardList.vue?vue&type=script&lang=js&"
export * from "./DashboardList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardList.vue?vue&type=style&index=0&id=020a85ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a85ef",
  null
  
)

export default component.exports